var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Modal } from '@doordash/component-modal';
import { useToast } from '@doordash/component-toast';
import { Icon, Inset, StackChildren, InlineChildren, Text, } from '@doordash/design-language';
import Button from '@doordash/component-button';
import { unwrapResult } from '@reduxjs/toolkit';
import styled from 'styled-components';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { removeTeamAccountGroupMember } from '../groups_members_slice';
import track from '../../../utils/track';
export var ButtonGroupContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 200px;\n"], ["\n  max-width: 200px;\n"])));
export var RemoveGroupMemberModal = function (_a) {
    var onGroupMemberRemoved = _a.onGroupMemberRemoved, onClose = _a.onClose, groupMember = _a.groupMember, group = _a.group;
    var dispatch = useDispatch();
    var displayToast = useToast().displayToast;
    var _b = __read(React.useState(''), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = __read(React.useState(false), 2), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var handleRemoveGroupMember = React.useCallback(function () {
        setIsSubmitting(true);
        dispatch(removeTeamAccountGroupMember({
            groupId: group.id,
            groupMemberId: groupMember.id,
        }))
            .then(unwrapResult)
            .then(function () {
            track('workportal_submit_remove_group_member', {
                name: group.name,
            });
            displayToast({
                icon: Icon.Types.Check,
                text: "Employee removed successfully",
                insetFromEdge: Inset.Sizes.XxxLarge,
            });
            onGroupMemberRemoved();
            onClose();
        }, function () {
            setIsSubmitting(false);
            setErrorMessage('There was an error.');
        });
    }, [groupMember, group]);
    return (React.createElement(Modal, { onClose: onClose, title: "Remove Employee from " + group.name },
        React.createElement(StackChildren, { size: StackChildren.Sizes.Small },
            React.createElement(Text, { color: Text.Colors.TextSecondary },
                "Are you sure you want to remove ",
                groupMember.teamAccountMember.email,
                ' ',
                "from ",
                group.name,
                "?"),
            errorMessage && (React.createElement(InlineChildren, { size: InlineChildren.Sizes.XxSmall, alignItems: InlineChildren.Alignment.FlexStart },
                React.createElement(Icon, { size: Icon.Sizes.Medium, type: Icon.Types.ErrorFill, color: Icon.Colors.SystemRed80 }),
                React.createElement(Text, { color: Text.Colors.SystemRed80 }, errorMessage))),
            React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center, justifyContent: InlineChildren.Justification.FlexEnd },
                React.createElement(ButtonGroupContainer, null,
                    React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                        React.createElement(Button, { type: Button.Types.TertiaryPill, onClick: onClose }, "Cancel"),
                        React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: handleRemoveGroupMember, disabled: isSubmitting, state: isSubmitting ? Button.States.Loading : Button.States.Default, "data-anchor-id": "groupMemberRemoveButton" }, "Remove")))))));
};
export default RemoveGroupMemberModal;
var templateObject_1;
